import Home from './components/Home.vue'
import AC from './components/web apps/AC.vue'
import {createRouter, createWebHistory} from 'vue-router'

const routes=[
    {
        name: 'Home',
        component: Home,
        path: '/'
    },
    {
        name: 'AC',
        component: AC,
        path: '/AC'
    }
]

const router =createRouter({
    history:createWebHistory(),
    routes
})

export default router